import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

export default function FacebookMetadataIcon() {
  return (
    <div className="itemMetadata-facebookIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faFacebook} />
    </div>
  );
}
